<div class="calculator-dialog-container">
    <!-- Example usage of a separate Numpad component (or legacy directive) -->
    <tt-numpad-legacy [label]="data.label"
                      [plabel]="data.plabel"
                      [field]="data.field"
                      (enter)="onEnter($event)"></tt-numpad-legacy>
</div>
